export const skills = [
	{
		title: "HTML",
		icon: "devicon-html5-plain",
	},
	{
		title: "CSS",
		icon: "devicon-css3-plain",
	},
    {
		title: "Python",
		icon: "devicon-python-plain",
	},
    {
		title: "Java",
		icon: "devicon-java-plain",
	},
    {
		title: "Spring",
		icon: "devicon-spring-plain",
	},
	{
		title: "JavaScript",
		icon: "devicon-javascript-plain",
	},
    {
		title: "Typescript",
		icon: "devicon-typescript-plain",
	},
	{
		title: "Node.js",
		icon: "devicon-nodejs-plain",
	},
	{
		title: "React",
		icon: "devicon-react-original",
		animation: "spin-animation",
	},
	{
		title: "Redux",
		icon: "devicon-redux-original",
		animation: "spin-animation",
	},
	{
		title: "Angular",
		icon: "devicon-angularjs-plain",
	},
	{
		title: "Github",
		icon: "devicon-github-original",
	},
	{
		title: "Git",
		icon: "devicon-git-plain",
	},
	{
		title: "VS Code",
		icon: "devicon-vscode-plain",
	},
	{
		title: "IntelliJ",
		icon: "devicon-intellij-plain",
	},
	{
		title: "MongoDB",
		icon: "devicon-mongodb-plain",
	},
	{
		title: "postgreSQL",
		icon: "devicon-postgresql-plain",
	},
	{
		title: "mySQL",
		icon: "devicon-mysql-plain",
	},
];
